import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { getRequest } from '../_api';
import { IRequestsEditPatientDetailEdit } from './_types';
import { IExistingRequest } from '../_types';
import StudiesEditDetail from 'modules/Studies/StudiesEdit/StudiesEditDetail';
import { useEntityInfo } from 'utils/hooks/useEntityInfo';
import { EDIT_TYPE_PATIENT_SLUG } from 'constants/constants';

const RequestsEditPatientDetailEdit: React.FC<IRequestsEditPatientDetailEdit> = () => {
  const { id } = useEntityInfo();
  const navigate = useNavigate();

  const [request, fetchRequest] = useState<IExistingRequest>();

  const loadEntity = async () => {
    if (id) {
      const request = await getRequest(parseInt(id.toString(), 10));
      if (request) {
        fetchRequest(request);
      } else {
        navigate('/requests/edit');
      }
    }
  };

  useEffect(() => {
    loadEntity();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {request ? (
        <StudiesEditDetail
          isRequest={true}
          isRequestEdit={true}
          request={request}
          operationType={EDIT_TYPE_PATIENT_SLUG}
        />
      ) : null}
    </>
  );
};

export default RequestsEditPatientDetailEdit;
